import { HdDate } from "./hd-date";
export class Utils {
    public static regularIso: RegExp = new RegExp(/[0-9]{4}\-[0-9][0-9]?\-[0-9][0-9]?[T]?[0-9][0-9]?:[0-9][0-9]?:[0-9][0-9]?\.?[0-9]?[0-9]?[0-9]?/);
    public static formatISO = "yyyy-MM-dd HH:mm:ss.fffffffff";
    public static formatDefault = "MM/dd/yyyy hh:mm:ss.fffffffff tt";
    public static denominator = 1000;
    public static hours: number;
    public static regularLetters = /[A-Za-z]+/ig;
    public static regularTime = "[0-9][0-9]?:[0-9][0-9]?:[0-9][0-9]?";
    public static regularDate = "[A-Za-z]{3}\,? [A-Za-z]{3} [0-9]{2} [0-9]{4}";
    public static regularLocalDate = "[A-Z][a-z]+ [0-9]+\, [0-9]+";
    public static regularUTCDate = "[A-Za-z]{3}, [0-9]{2} [A-Za-z]{3} [0-9]{4}";

    public static getFullNameDigit(digit: string): string {
        if (digit === "MM") {
            return "Month";
        } else if (digit === "dd") {
            return "Date";
        } else if (digit === "yyyy" || digit === "yy") {
            return "FullYear";
        } else if (digit === "HH" || digit === "hh") {
            return "Hours";
        } else if (digit === "mm") {
            return "Minutes";
        } else if (digit === "ss") {
            return "Seconds";
        }
        return "Milliseconds";
    }
    public static getEndTime(hdDate: HdDate): string {
        let sec = hdDate.getSeconds().toString();
        if (sec.length < 3) {
            sec = this.padStart(2 - sec.length, sec);
        }
        return `:${sec} `;
    }
    public static getValueDigit(date: HdDate, format: string[]): string[] {
        let values: string[] = [];
        for (let i = 0; i < format.length; i++) {
            if (format[i] === "tt") {
                if (date.getHours() > 12) {
                    values.push("PM");
                } else {
                    values.push("AM");
                }
            } else if (format[i] === "yy") {
                values.push(date.getFullYear().toString().slice(2, 4));
            } else if (format[i] === "hh") {
                if (date.getHours() >= 13) {
                    values.push((date.getHours() - 12).toString());
                } else {
                    values.push((date.getHours()).toString());
                }
            } else {
                if (format[i].length === 3) {
                    let mili = date.getMilliseconds().toString();
                    if (mili.length < 3) {
                        mili = this.padStart(3 - mili.length, mili);
                    }
                    values.push(mili);
                } else if (format[i].length === 6) {
                    let mili = date.getMilliseconds().toString();
                    let micro = date.getMicroseconds().toString();
                    if (mili.length < 3) {
                        mili = this.padStart(3 - mili.length, mili);
                    }
                    if (micro.length < 3) {
                        micro = this.padStart(3 - micro.length, micro);
                    }
                    values.push(mili + micro);
                } else if (format[i].length === 9) {
                    let mili = date.getMilliseconds().toString();
                    let nanosFraction = date.getNanosFraction().toString();
                    if (mili.length < 3) {
                        mili = this.padStart(3 - mili.length, mili);
                    }
                    if (nanosFraction.length < 6) {
                        nanosFraction = this.padStart(6 - nanosFraction.length - 1, nanosFraction);
                    }
                    values.push(mili + nanosFraction);
                } else {
                    const nameDigit = this.getFullNameDigit(format[i]);
                    if (nameDigit === "Month") {
                        values.push((date[`get${nameDigit}`]() + 1).toString());
                    } else {
                        values.push((date[`get${nameDigit}`]()).toString());
                    }
                }
            }
        }
        return values;
    }

    public static formString(values: string[], format: string, formatString?: string): string {
        const separators = format.match(/[\/,\-,\.,\:,\,,\\,\s]/ig);
        const letters = formatString != null ? formatString.match(this.regularLetters) : null;
        const arrayFormat: string[] = format.match(this.regularLetters);
        let str = "";
        let count = 0;
        for (let i = 0; i < arrayFormat.length; i++) {
            if (values[i] != null) {
                if (arrayFormat[i].length > values[i].length) {
                    if (arrayFormat[i].length === 3 || arrayFormat[i].length === 6 || arrayFormat[i].length === 9) {
                        const val = (values[i].length < 3) ? this.padStart(3 - values[i].length, values[i]) : values[i];
                        str += val + this.padStart(arrayFormat[i].length - val.length, "");
                    } else {
                        str += this.padStart(arrayFormat[i].length - values[i].length, values[i]);
                    }
                } else {
                    str += values[i];
                }
            } else {
                if (arrayFormat[i] === "tt") {
                    str += letters != null ? letters[0] : (this.hours > 12) ? "PM" : "AM";
                } else {
                    str += this.padStart(arrayFormat[i].length, "");
                }
            }

            if (separators[count] != null) {
                str += separators[count];
                count++;
            }
        }
        return str;
    }

    public static padStart(numberSymbol: number, word: string): string {
        while (numberSymbol !== 0) {
            word = "0" + word;
            numberSymbol--;
        }
        return word;
    }

    public static setValue(digit: string, value: number, date: HdDate) {
        if (digit.length >= 3 && digit.length !== 4) {
            if (digit.length === 3) {
                date.setMilliseconds(value);
            } else if (digit.length === 6 || digit.length === 9) {
                let mili = value.toString().slice(0, 3);
                let nanoFr = value.toString().slice(3, value.toString().length);
                if (mili !== "") {
                    date.setMilliseconds(Number(mili));
                }
                if (nanoFr !== "") {
                    if (nanoFr.length < 4) {
                        date.setNanosFraction(Number(nanoFr) * 1000);
                    } else {
                        date.setNanosFraction(Number(nanoFr));
                    }
                }
            }
        } else {
            const nameDigit = this.getFullNameDigit(digit);
            if (nameDigit != null) {
                if (nameDigit === "Month") {
                    date[`set${nameDigit}`](value - 1);
                } else {
                    date[`set${nameDigit}`](value);
                }
            }
        }
    }

    public static getValue(values: string[], digit: string): string {
        let arrayValues: string[] = [];
        for (let i = 0; i < 3; i++) {
            if (digit === "yyyy" && values[i].length === 4) {
                return values[i];
            } else if (values[i].length !== 4) {
                arrayValues.push(values[i]);
            }
        }

        for (const value of arrayValues) {
            if (digit === "dd" && parseInt(value) > 12) {
                return value;
            } else if (digit === "MM" && parseInt(value) <= 12) {
                return value;
            }
        }
        return arrayValues[arrayValues.length - 1];
    }

    public static convertDate(values: string, format: string[]): string[] {
        const createdValues: string[] = [];
        const letters = values.match(this.regularLetters);
        const separator = values.match(/[\/,\-,\.,\\]/);
        const arrayValues: string[] = values.match(/\d+/ig);
        let count = 0;
        for (let i = 0; i < format.length; i++) {
            if (separator != null) {
                if (format[0] === "yyyy" || arrayValues[0].length === 4) {
                    if (format[i] === "dd" || format[i] === "MM" || format[i] === "yyyy" || format[i] === "yy") {
                        createdValues.push(this.getValue(arrayValues, format[i]));
                        count++;
                    }
                } else {
                    if (separator[0] === "." || separator[0] === "-" || separator[0] === ",") {
                        if (format[i] === "dd") {
                            createdValues.push(arrayValues[0]);
                            count++;
                        } else if (format[i] === "MM") {
                            createdValues.push(arrayValues[1]);
                            count++;
                        } else if (format[i] === "yyyy") {
                            createdValues.push(this.getValue(arrayValues, format[i]));
                            count++;
                        } else if (format[i] === "yy") {
                            createdValues.push(arrayValues[2]);
                            count++;
                        }
                    } else {
                        if (format[i] === "dd" || format[i] === "MM" || format[i] === "yyyy" || format[i] === "yy") {
                            createdValues.push(this.getValue(arrayValues, format[i]));
                            count++;
                        } else if (format[i] === "yy") {
                            createdValues.push(arrayValues[2]);
                            count++;
                        }
                    }
                }
            }
            if (!isNaN(parseInt(arrayValues[count]))) {
                if (format[i] === "HH") {
                    this.hours = parseInt(arrayValues[count]);
                    if (letters != null && letters[0] === "PM") {
                        createdValues.push(this.correctHours(arrayValues[count], format[i]));
                    } else {
                        createdValues.push(arrayValues[count]);
                    }
                    count++;
                } else if (format[i] === "hh") {
                    this.hours = parseInt(arrayValues[count]);
                    createdValues.push(this.correctHours(arrayValues[count], format[i]));
                    count++;
                } else if (format[i] === "mm") {
                    createdValues.push(arrayValues[count]);
                    count++;
                } else if (format[i] === "ss") {
                    createdValues.push(arrayValues[count]);
                    count++;
                } else if (format[i].length === 3 || format[i].length === 6 || format[i].length === 9) {
                    createdValues.push(arrayValues[count].slice(0, format[i].length));
                    count++;
                }
            }
        }
        return createdValues;
    }

    public static correctHours(value: string, digit: string): string {
        let returnValue = value;
        if (digit === "HH" && parseInt(value) < 12) {
            returnValue = (parseInt(value) + 12).toString();
        } else if (digit === "hh" && parseInt(value) > 12) {
            returnValue = (parseInt(value) - 12).toString();
        }

        if (returnValue.length === 1) {
            return ("0" + returnValue);
        } else {
            return returnValue;
        }
    }

    public static checkData(allData: string, digit: string, value: string, hdDate: HdDate): boolean {
        const nameDigit = this.getFullNameDigit(digit);
        if (nameDigit === "Month" && hdDate[`get${nameDigit}`]() + 1 !== parseInt(value)) {
            return false;
        } else if (nameDigit === "Date" && hdDate[`get${nameDigit}`]() !== parseInt(value)) {
            return false;
        }
        return true;
    }
}